import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, eur, fmtDate } from "../lib/api";
import { Plus, FileText } from "lucide-react";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

const statusColor = {
  borrador: "bg-white/10 text-white/70",
  enviado: "bg-brand-cyan/15 text-brand-cyan",
  aceptado: "bg-emerald-500/15 text-emerald-400",
  rechazado: "bg-red-500/15 text-red-400",
  facturado: "bg-brand-orange/15 text-brand-orange",
};

export default function EstimatesList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/estimates").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 animate-fade-in" data-testid="estimates-page">
      <header className="flex justify-between items-end flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cyan mb-2">Presupuestos</div>
          <h1 className="font-display font-bold text-4xl tracking-tight">Presupuestos</h1>
        </div>
        <Link to="/app/presupuestos/nuevo">
          <Button data-testid="new-estimate-btn" className="bg-brand-orange hover:bg-brand-orange-hover text-white">
            <Plus className="w-4 h-4 mr-2" /> Nuevo presupuesto
          </Button>
        </Link>
      </header>

      <div className="rounded-lg border border-white/10 bg-[#0A1128]/40 overflow-hidden">
        {loading ? (
          <div className="p-12 text-center text-white/50">Cargando...</div>
        ) : items.length === 0 ? (
          <div className="p-16 text-center" data-testid="estimates-empty">
            <FileText className="w-12 h-12 mx-auto text-white/20 mb-3" strokeWidth={1} />
            <div className="text-white/60 mb-4">Aún no tienes presupuestos.</div>
            <Link to="/app/presupuestos/nuevo">
              <Button className="bg-brand-cyan hover:bg-brand-cyan-hover text-surface-base font-semibold">Crear el primero</Button>
            </Link>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b border-white/10 text-[10px] uppercase tracking-widest text-white/50">
                <th className="p-4 font-bold">Nº</th>
                <th className="p-4 font-bold">Cliente</th>
                <th className="p-4 font-bold">Fecha</th>
                <th className="p-4 font-bold">Estado</th>
                <th className="p-4 font-bold text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {items.map((e) => (
                <tr key={e.id} onClick={() => navigate(`/app/presupuestos/${e.id}`)} className="border-b border-white/5 hover:bg-white/5 cursor-pointer transition-colors" data-testid={`estimate-row-${e.id}`}>
                  <td className="p-4 font-mono text-xs">{e.number}</td>
                  <td className="p-4">{e.client_snapshot?.name || "—"}</td>
                  <td className="p-4 text-white/60">{fmtDate(e.created_at)}</td>
                  <td className="p-4"><span className={`px-2 py-1 rounded text-[10px] uppercase font-bold ${statusColor[e.status] || "bg-white/10"}`}>{e.status}</span></td>
                  <td className="p-4 text-right font-semibold">{eur(e.total || 0)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
